/** Consultation booking destination for every report CTA. */
export const BOOKING_URL = 'https://calendar.app.google/8MVGwNoYa5qjheLh9';

/**
 * The same appointment schedule in Google's embeddable form (HAL-2083).
 *
 * `BOOKING_URL` redirects to `calendar.google.com/appointments/schedules/<id>`,
 * which answers `X-Frame-Options: SAMEORIGIN` and cannot be framed. The
 * `/calendar/appointments/...?gv=true` variant of the same id sends neither
 * that header nor a `frame-ancestors` directive, which is what lets the booking
 * modal show the calendar inline. Measured 2026-11-01. If Google ever starts
 * refusing the frame, the modal's "New tab" link still reaches `BOOKING_URL`;
 * the slow-load button will not appear, because a browser fires `load` on a
 * frame it refused to render.
 */
export const BOOKING_EMBED_URL =
  'https://calendar.google.com/calendar/appointments/schedules/AcZssZ0bkwA-wP5veeSEvmW34k2OS3vzEdxoTjVDJLERiHIssVNpPNQNmR8CCFh8ZSn-E4Q4jRaik1UZ?gv=true';
